// import AutoSubmit from '@stimulus-components/auto-submit'
import { Controller } from '@hotwired/stimulus'
import { useDebounce } from 'stimulus-use'
import { stimulus } from '~/init'

class RemoteAutosaveController extends Controller {
  static debounces = ['submit']
  static values = {
    delay: {
      type: Number,
      default: 250
    }
  }

  initialize () {
    this.submit = this.submit.bind(this)
  }

  connect () {
    useDebounce(this, { wait: this.delayValue })
    this.form = document.getElementById(this.element.getAttribute('data-remote-form'))

    if (!this.form) {
      return false
    }
  }

  submit () {
    this.form.requestSubmit()
  }

  submitWithouDelay () {
    this.form.requestSubmit()
  }
}

stimulus.register('remote-autosave', RemoteAutosaveController)
